import { IDmEmailConfig } from "../../../models/response/email/IDmEmailConfig";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from '../IGenericActionType';

export const eDmEmailConfigDefine = {
    LOAD_START: undefined,
    LOAD_SUCCCES: [] as IDmEmailConfig[],
    LOAD_ERROR: "",
    SHOW_EDIT_MODAL: {} as IDmEmailConfig | undefined,
    CLOSE_EDIT_MODAL: undefined,
    SAVE_START: {} as IDmEmailConfig,
    SAVE_SUCESS: {} as IDmEmailConfig,
    SAVE_ERROR: "",
    DELETE_START: 0,
    DELETE_SUCESS: undefined,
    DELETE_ERROR: ""
}
export const eEmailConfigActionTypeIds = generateActionTypeIds(eDmEmailConfigDefine, "EMAIL_CONFIG")
export type IDmEmailConfigActionTypes = IGenericActionType<typeof eDmEmailConfigDefine, "EMAIL_CONFIG">
